{
  "accountHolderName": "Account Holder Name",
  "statementDate": "Statement Date",
  "bankName": "Bank Name",
  "accountNumber": "Account Number",
  "totalCredits": "Total Credits",
  "totalDebits": "Total Debits",
  "openingBalance": "Opening Balance",
  "bankBalance": "Bank Balance",
  "nonCurrentAssetsSubsidiaryCompanies": "Subsidiary Companies (Non-Current Assets)",
  "nonCurrentAssetsAssociatedCompanies": "Associated Companies (Non-Current Assets)",
  "nonCurrentAssetsDevelopmentPropertiesOrExpenditure": "Development Properties/Expenditure (Non-Current Assets)",
  "nonCurrentAssetInvestmentProperties": "Investment Properties (Non-Current Assets)",
  "nonCurrentAssetsInvestments": "Investments (Non-Current Assets)",
  "nonCurrentAssetInvestmentSecurities": "Investment Securities (Non-Current Assets)",
  "nonCurrentAssetDeferredAssets": "Deferred Assets (Non-Current Assets)",
  "nonCurrentAssetDeposits": "Deposits (Non-Current Assets)",
  "nonCurrentAssetOwnGoodwill": "Own Goodwill (Non-Current Assets)",
  "nonCurrentAssetGoodwillOnConsolidation": "Goodwill on Consolidation (Non-Current Assets)",
  "nonCurrentAssetSinkingFund": "Sinking Fund (Non-Current Assets)",
  "nonCurrentAssetPropertyPlantEquipment": "Property, Plant & Equipment (Non-Current Assets)",
  "nonCurrentAssetInventories": "Inventories (Non-Current Assets)",
  "nonCurrentAssetRightOfUseAssets": "Right of Use Assets (Non-Current Assets)",
  "nonCurrentAssetIntangibleAssets": "Intangible Assets (Non-Current Assets)",
  "nonCurrentAssetPrepaidLeasePayments": "Prepaid Lease Payments (Non-Current Assets)",
  "nonCurrentAssetFinancialAssetAtFairValue": "Financial Assets at Fair Value (Non-Current Assets)",
  "nonCurrentAssetLandUseRight": "Land Use Rights (Non-Current Assets)",
  "nonCurrentAssetTradeReceivables": "Trade Receivables (Non-Current Assets)",
  "nonCurrentAssetOtherReceivables": "Other Receivables (Non-Current Assets)",
  "nonCurrentAssetTradeAndOtherReceivables": "Trade and Other Receivables (Non-Current Assets)",
  "nonCurrentAssetOtherReceivablesDepositsAndPrepayments": "Other Receivables, Deposits and Prepayments (Non-Current Assets)",
  "totalNonCurrentAssets": "Total Non-Current Assets",
  "currentAssetDevelopmentPropertiesOrExpenditure": "Development Properties/Expenditure (Current Assets)",
  "currentAssetShortTermInvestments": "Short Term Investments (Current Assets)",
  "currentAssetTradeDebtors": "Trade Debtors (Current Assets)",
  "currentAssetShortTermDeposits": "Short Term Deposits (Current Assets)",
  "currentAssetAmountDueFromHoldingCompany": "Amount Due from Holding Company (Current Assets)",
  "currentAssetAmountDueFromSubsidiaryCompanies": "Amount Due from Subsidiary Companies (Current Assets)",
  "currentAssetAmountDueFromAssociatedCompanies": "Amount Due from Associated Companies (Current Assets)",
  "currentAssetAmountDueFromDirector": "Amount Due from Director (Current Assets)",
  "currentAssetAmountDueFromCustomer": "Amount Due from Customer (Current Assets)",
  "currentAssetAmountOwingByShareholders": "Amount Owing by Shareholders (Current Assets)",
  "currentAssetInventories": "Inventories (Current Assets)",
  "currentAssetFinancialAssetAtFairValue": "Financial Assets at Fair Value (Current Assets)",
  "currentAssetLandUseRight": "Land Use Rights (Current Assets)",
  "currentAssetTaxRecoverable": "Tax Recoverable (Current Assets)",
  "currentAssetContractAssets": "Contract Assets (Current Assets)",
  "currentAssetCurrentTaxAssets": "Current Tax Assets (Current Assets)",
  "currentAssetPrepayments": "Prepayments (Current Assets)",
  "currentAssetDerivative": "Derivatives (Current Assets)",
  "currentAssetCashAndBankBalances": "Cash and Bank Balances (Current Assets)",
  "currentAssetOtherReceivables": "Other Receivables (Current Assets)",
  "currentAssetRestrictedCash": "Restricted Cash (Current Assets)",
  "currentAssetCashAndCashEquivalents": "Cash and Cash Equivalents (Current Assets)",
  "currentAssetDepositsCashAndBankBalances": "Deposits, Cash and Bank Balances (Current Assets)",
  "currentAssetCashAtBanks": "Cash at Banks (Current Assets)",
  "currentAssetCashOnHand": "Cash on Hand (Current Assets)",
  "currentAssetDepositsAndPrepayments": "Deposits and Prepayments (Current Assets)",
  "currentAssetTradeAndOtherReceivables": "Trade and Other Receivables (Current Assets)",
  "currentAssetOtherReceivablesDepositsAndPrepayments": "Other Receivables, Deposits and Prepayments (Current Assets)",
  "currentAssetOtherReceivablesAndDeposits": "Other Receivables and Deposits (Current Assets)",
  "currentAssetOtherReceivablesAndPrepayments": "Other Receivables and Prepayments (Current Assets)",
  "currentAssetCash": "Cash (Current Assets)",
  "totalCurrentAssets": "Total Current Assets",
  "totalAssets": "Total Assets",
  "currentLiabilitiesTradeCreditors": "Trade Creditors (Current Liabilities)",
  "currentLiabilitiesHirePurchasePayables": "Hire Purchase Payables (Current Liabilities)",
  "currentLiabilitiesBankOverdraft": "Bank Overdraft (Current Liabilities)",
  "currentLiabilitiesBankAcceptance": "Bank Acceptance (Current Liabilities)",
  "currentLiabilitiesBorrowingsOrTermLoans": "Borrowings/Term Loans (Current Liabilities)",
  "currentLiabilitiesBankborrowings": "Bank Borrowings (Current Liabilities)",
  "currentLiabilitiesAmountsOwingToHoldingCompany": "Amounts Owing to Holding Company (Current Liabilities)",
  "currentLiabilitiesAmountsOwingToSubsidiaryCompanies": "Amounts Owing to Subsidiary Companies (Current Liabilities)",
  "currentLiabilitiesAmountOwingToAssociatedCompanies": "Amount Owing to Associated Companies (Current Liabilities)",
  "currentLiabilitiesAmountsOwingToDirector": "Amounts Owing to Director (Current Liabilities)",
  "currentLiabilitiesProvisionForTaxation": "Provision for Taxation (Current Liabilities)",
  "currentLiabilitiesLeasePayables": "Lease Payables (Current Liabilities)",
  "currentLiabilitiesFinanceLeasePayables": "Finance Lease Payables (Current Liabilities)",
  "currentLiabilitiesOtherPayables": "Other Payables (Current Liabilities)",
  "currentLiabilitiesDividendPayables": "Dividend Payables (Current Liabilities)",
  "currentLiabilitiesTradeAndOtherPayables": "Trade and Other Payables (Current Liabilities)",
  "currentLiabilitiesDepositsFromCustomers": "Deposits from Customers (Current Liabilities)",
  "currentLiabilitiesOtherPayablesAccrualsAndDeposits": "Other Payables, Accruals and Deposits (Current Liabilities)",
  "currentLiabilitiesOtherPayablesAndAccruals": "Other Payables and Accruals (Current Liabilities)",
  "currentLiabilitiesContractLiabilities": "Contract Liabilities (Current Liabilities)",
  "currentLiabilitiesDerivative": "Derivative Liabilities (Current Liabilities)",
  "totalCurrentLiabilities": "Total Current Liabilities",
  "shortTermLiabilities": "Short Term Liabilities",
  "nonCurrentLiabilitiesBorrowingsOrTermLoans": "Borrowings/Term Loans (Non-Current Liabilities)",
  "nonCurrentLiabilitiesBankBorrowings": "Bank Borrowings (Non-Current Liabilities)",
  "nonCurrentLiabilitiesLeaseObligations": "Lease Obligations (Non-Current Liabilities)",
  "nonCurrentLiabilitiesFinanceLeaseObligations": "Finance Lease Obligations (Non-Current Liabilities)",
  "nonCurrentLiabilitiesDeferredTaxation": "Deferred Taxation (Non-Current Liabilities)",
  "nonCurrentLiabilitiesRetirementBenefits": "Retirement Benefits (Non-Current Liabilities)",
  "nonCurrentLiabilitiesHirePurchasePayables": "Hire Purchase Payables (Non-Current Liabilities)",
  "nonCurrentLiabilitiesDepositsFromCustomers": "Deposits from Customers (Non-Current Liabilities)",
  "nonCurrentLiabilitiesContractLiabilities": "Contract Liabilities (Non-Current Liabilities)",
  "totalNonCurrentLiabilities": "Total Non-Current Liabilities",
  "totalLiabilities": "Total Liabilities",
  "tangibleAssets": "Tangible Assets",
  "shareCapital": "Share Capital",
  "preferenceShareCapital": "Preference Share Capital",
  "sharePremium": "Share Premium",
  "reserves": "Reserves",
  "capitalReserves": "Capital Reserves",
  "revaluationReserves": "Revaluation Reserves",
  "exchangeEqualisationOrFluctuationReserves": "Exchange Equalisation/Fluctuation Reserves",
  "retainedEarnings": "Retained Earnings",
  "totalEquity": "Total Equity",
  "revenue": "Revenue",
  "costOfGoodsSold": "Cost of Goods Sold",
  "grossProfit": "Gross Profit",
  "otherIncome": "Other Income",
  "profitFromOperations": "Profit from Operations",
  "financeCost": "Finance Cost",
  "ebitda": "Profit Before Tax",
  "taxes": "Taxes",
  "zakat": "Zakat",
  "profitAfterTax": "Profit After Tax",
  "netProfit": "Net Profit",
  "netOperatingCashFlow": "Net Operating Cash Flow",
  "depreciation": "Depreciation",
  "depreciationOfPropertyPlantEquipment": "Depreciation of Property, Plant & Equipment",
  "depreciationRightOfUseAssets": "Depreciation of Right of Use Assets",
  "depreciationOfInvestmentProperties": "Depreciation of Investment Properties",
  "depreciationOfInvestmentSecurities": "Depreciation of Investment Securities",
  "endOfYearCash": "End of Year Cash",
  "epfAccountHolderName": "Account Holder Name",
  "epfAccountHolderAddress": "Account Holder Address",
  "epfStatementYear": "Statement Year",
  "epfKwspMemberNumber": "KWSP Member Number",
  "epfIcNumber": "IC No.",
  "epfEmployerNumber": "Employer Number",
  "epfDateOfStatement": "Date Of Statement",
  "epfTotalContribution": "Total Contribution",
  "epfTotalCurrentContribution": "Total Current Contribution",
  "payslipEmployerName": "Employer Name",
  "payslipEmployeeName": "Employee Name",
  "payslipPayPeriod": "Pay Period",
  "payslipPayDate": "Pay Date",
  "payslipGrossPay": "Gross Pay",
  "payslipDeduction": "Deduction",
  "payslipEmployeeEpfContribution": "Employee EPF Contribution",
  "payslipEmployeeSocsoContribution": "Employee SOCSO Contribution",
  "payslipNetPay": "Net Pay",
  "incorporatedDate": "Incorporated Date",
  "companyName": "Company Name",
  "companyRegNo": "Company Registration No.",
  "ssmCompanyName": "Company Name (SSM)",
  "ssmCompanyRegNo": "Registration No. (SSM)",
  "ssmCompanyEntityType": "Entity Type (SSM)",
  "ssmPaidUpCapital": "Paid-Up Capital (SSM)",
  "businessCommencementDate": "Business Commencement Date",
  "businessNature": "Business Nature",
  "companyStatus": "Company Status",
  "shareholders": "Shareholders",
  "directors": "Directors",
  "previousDirectors": "Previous Directors",
  "totalShareIssued": "Total Shares Issued",
  "companyLastOldName": "Previous Company Name",
  "companyNameDateOfChange": "Company Name Change Date",
  "businessOrigin": "Business Origin",
  "registeredAddress": "Registered Address",
  "icName": "Name (IC)",
  "icNumber": "IC Number",
  "icAddress": "Address (IC)",
  "icGender": "Gender (IC)",
  "icReligion": "Religion (IC)",
  "icDateOfBirth": "Date of Birth (IC)",
  "icPlaceOfBirth": "Place of Birth (IC)",
  "icNationality": "Nationality (IC)",
  "icRace": "Race (IC)"
}
